export default __webpack_public_path__ + "static/media/Rectangle 1484631.12cc3a21.png";